/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import React, { useEffect, useRef, useState } from 'react'
import { ComboBox } from '@progress/kendo-react-dropdowns'
import { Tooltip } from '@progress/kendo-react-tooltip'

import { HighlightText } from '@/matteroomTab/HighlightText'
import { cn } from '@utils/mergeClassNames'
import CLOSE_ICON from '@public/assets/action/close_circle.svg'
import WARNING_ICON from '@public/assets/action/warning-circle.svg'
import ARROW_DOWN_ICON from '@public/assets/arrow-down.svg'

const activityOptions = [
  'Meeting',
  'Email',
  'Research',
  'Document',
  '(Not Specified)',
]

const EditableMyCaseActivityField = ({
  value,
  onChange,
  error,
  required = true,
}) => {
  const [status, setStatus] = useState('default')
  const [filterOptions, setFilterOptions] = useState(activityOptions)
  const [search, setSearch] = useState('')
  const fieldRef = useRef(null)
  const comboRef = useRef(null)
  const displayValue = value || ''
  const hasValue = String(displayValue).trim().length > 0

  useEffect(() => {
    if (status === 'focus') return
    if (error) setStatus('error')
    else if (hasValue) setStatus('filled')
    else setStatus('default')
  }, [hasValue, error])

  useEffect(() => {
    const handleClickOutside = event => {
      setTimeout(() => {
        const dropdown = document.querySelector('.k-animation-container')
        const clickInsideField = fieldRef.current?.contains(event.target)
        const clickInsideDropdown = dropdown?.contains(event.target)

        if (status === 'focus' && !clickInsideField && !clickInsideDropdown) {
          setStatus(hasValue ? 'filled' : 'default')
        }
      }, 0)
    }

    document.addEventListener('mouseup', handleClickOutside)
    return () => document.removeEventListener('mouseup', handleClickOutside)
  }, [status, hasValue])

  useEffect(() => {
    if (status !== 'focus') return

    setFilterOptions(activityOptions)
    setSearch('')
    setTimeout(() => {
      comboRef.current?.focus()
      comboRef.current?.toggleBtnClick()
    }, 0)
  }, [status])

  const renderPlaceholder = () => (
    <span className="min-w-[60px] text-sm font-normal text-[#999]">
      {required && <span className="text-[#E25750]">*</span>}
      Activity
    </span>
  )

  return (
    <div
      ref={fieldRef}
      className={cn(
        'code-field default group min-w-0 text-sm',
        status,
        'w-[180px] flex-[0_0_180px]'
      )}
      onMouseEnter={() => status === 'default' && setStatus('hover')}
      onMouseLeave={() => status === 'hover' && setStatus('default')}
    >
      {status === 'focus' ? (
        <>
          <div className="relative">
            <ComboBox
              ref={comboRef}
              className={`search-combobox relative flex w-full items-center text-sm [&.k-combobox.k-focus]:!shadow-none [&.k-combobox:focus-within]:!shadow-none [&_.k-input-button]:!my-2 [&_.k-input-button]:!h-6 [&_.k-input-button]:!rounded-none [&_.k-input-button]:!border-0 [&_.k-input-button]:!border-l [&_.k-input-button]:!border-solid [&_.k-input-button]:!border-l-[#D9D9D9] [&_.k-input-button_.k-icon]:!invisible [&_.k-input-inner]:!border-0 [&_.k-input-inner]:!bg-transparent [&_.k-input-inner]:!text-sm [&_.k-input-inner]:!shadow-none ${hasValue ? 'is-filled [&_.k-input-inner]:!pr-7' : '[&_.k-input-inner]:!pr-2'}`}
              value={displayValue}
              placeholder="Select or enter"
              data={filterOptions}
              allowCustom
              clearButton={false}
              suggest
              filterable
              popupSettings={{
                className:
                  'search-combobox-popup custom-combobox-popup mt-1 box-border max-h-[220px] overflow-hidden rounded bg-white shadow-[0_4px_4px_rgba(0,0,0,0.10)]',
              }}
              onFilterChange={event => {
                const keyword = event.filter.value.trim().toLowerCase()
                setSearch(event.filter.value)
                setFilterOptions(
                  activityOptions.filter(option =>
                    option.toLowerCase().includes(keyword)
                  )
                )
              }}
              itemRender={(li, itemProps) => (
                <HighlightText
                  li={li}
                  name={String(itemProps.dataItem)}
                  highlight={search}
                />
              )}
              onChange={event => {
                const nextValue = String(event.value || '').trim()
                onChange(nextValue)
                setStatus(nextValue ? 'filled' : 'default')
              }}
            />
            {hasValue && (
              <img
                className="absolute right-8 top-1/2 z-10 h-4 w-4 -translate-y-1/2 cursor-pointer"
                src={CLOSE_ICON}
                onMouseDown={event => event.preventDefault()}
                onClick={() => onChange('')}
                alt="clear"
              />
            )}
            <img
              className="pointer-events-none absolute right-3 top-1/2 h-1.5 w-2 -translate-y-1/2"
              src={ARROW_DOWN_ICON}
              alt=""
            />
          </div>
          {error && <div className="error-text">{error}</div>}
        </>
      ) : status === 'error' ? (
        <>
          <div
            className="box-border flex h-10 cursor-pointer items-center gap-2 rounded border border-[#B3261E] px-1"
            onClick={() => setStatus('focus')}
          >
            {renderPlaceholder()}
            <img src={WARNING_ICON} className="h-4 w-4" alt="warning" />
            <img
              className="ml-auto mr-2 h-1.5 w-2"
              src={ARROW_DOWN_ICON}
              alt=""
            />
          </div>
          {error && <div className="error-text">{error}</div>}
        </>
      ) : (
        <>
          <div
            className={cn(
              'relative flex min-h-10 cursor-pointer items-center gap-2 rounded-md px-1 text-sm transition-colors',
              (status === 'hover' || status === 'filled') && 'bg-[#F5F5F5]',
              status === 'focus' && 'bg-[#D9D9D9]'
            )}
            onClick={() => setStatus('focus')}
          >
            {!hasValue && renderPlaceholder()}
            {hasValue && (
              <Tooltip anchorElement="target" position="top">
                <span
                  title={displayValue}
                  className="inline-block max-w-[360px] cursor-default truncate align-middle text-sm font-normal text-[#333]"
                >
                  {displayValue}
                </span>
              </Tooltip>
            )}
            <div className="ml-auto flex shrink-0 items-center gap-1.5">
              {hasValue && (
                <img
                  className="cursor-pointer"
                  src={CLOSE_ICON}
                  onClick={event => {
                    event.stopPropagation()
                    onChange('')
                  }}
                  alt="clear"
                />
              )}
              <img className="mx-2 h-1.5 w-2" src={ARROW_DOWN_ICON} alt="" />
            </div>
          </div>
          <div
            className={cn(
              'h-0.5 shrink-0 -translate-y-0.5 self-stretch rounded-sm',
              status === 'error'
                ? 'bg-[#B3261E]'
                : status === 'filled'
                  ? 'bg-white group-hover:bg-[#D9D9D9]'
                  : 'bg-[#D9D9D9]'
            )}
          ></div>
        </>
      )}
    </div>
  )
}

export default EditableMyCaseActivityField
